import React, { useEffect, useState } from 'react';
import './Testimonios.css';
import baseURL from '../url';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Testimonios() {
    const [testimonios, setTestimonios] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarTestimonios();
    }, []);

    const cargarTestimonios = () => {
        fetch(`${baseURL}/testimoniosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTestimonios(data.testimonios || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar testimonios:', error)
                setLoading(false);
            });
    };

    if (loading || testimonios.length === 0) {
        return null;
    }

    return (
        <div className='testimoniosContain'>
            <h2 className='testimoniosTitle'>Lo que dicen nuestros clientes</h2>
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                spaceBetween={20}
                autoplay={{ delay: 4000 }}
                pagination={{ clickable: true }}
                id='swiper_testimonios'
            >
                {testimonios.map((testimonio) => (
                    <SwiperSlide key={testimonio.idTestimonio} className='testimonioSlide'>
                        <div className='testimonioCard'>
                            {testimonio.foto && (
                                <img 
                                    src={testimonio.foto} 
                                    alt={testimonio.nombre} 
                                    className='testimonioFoto'
                                />
                            )}
                            {!testimonio.foto && (
                                <div className='testimonioFotoPlaceholder'>
                                    <span>{testimonio.nombre.charAt(0).toUpperCase()}</span>
                                </div>
                            )}
                            <h3 className='testimonioNombre'>{testimonio.nombre}</h3>
                            <p className='testimonioTexto'>"{testimonio.testimonio}"</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}



